// layouts/DashboardLayout/components/Header/Header.tsx
import { useAuth } from '../../../../contexts/AuthContext';
import { getGreeting } from '../../../../utils/helpers';
import { startPageTour } from '../../../../components/common/OnboardingTour/OnboardingTour';
import styles from './Header.module.css';

interface HeaderProps {
  onMenuToggle: () => void;
}

const Header = ({ onMenuToggle }: HeaderProps) => {
  const { user } = useAuth();
  const tierName = user?.tier?.name ?? '';
  const tierKey = String(tierName).toLowerCase();

  return (
    <header className={styles.header}>
      <button className={styles.menuToggle} onClick={onMenuToggle} aria-label="Menu">
        <span />
        <span />
        <span />
      </button>

      <div className={styles.greeting}>
        <h1>
          {getGreeting()}, {user?.name || 'Uživateli'}!
        </h1>
      </div>

      <div className={styles.actions}>
        <button
          className={styles.tourBtn}
          onClick={startPageTour}
          aria-label="Spustit interaktivního průvodce touto stránkou"
          title="Spustit interaktivního průvodce touto stránkou"
        >
          📖
        </button>
        <span className={`${styles.membershipBadge} ${styles[tierKey] ?? ''}`}>{tierName}</span>
      </div>
    </header>
  );
};

export default Header;
